//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
//  -- Features -----------------------
import React, { useEffect, useState } from 'react';
//  -- Constants ----------------------
import {ArrowRightRounded, CheckCircleRounded} from '@mui/icons-material';
import { Tooltip } from 'antd';
import { DeleteModal } from 'components/Dialog';
import Loading from 'components/Loading';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { handleGameDelete, handleListGame } from 'store/one_game/thunks';
import { useCurrentUser } from 'store/users/selectors';
import styled from "styled-components";
import { IGameHome8 } from "utils/assets/images";
import GameLoader from "./GameLoaader";
import { filter, get } from 'lodash';
const Cover = styled.div`
    width: 100%;   
    height: 230px;
    background-image: url(${p => p.src ? `'${p.src}'` : IGameHome8});
    background-size: 100%; 
    background-position: center; 
    background-repeat: no-repeat; 
`;
const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

// const settings = {
//     dots: false,
//     infinite: false,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 2,
//     prevArrow: <SamplePrevArrow />,
//     nextArrow: <SampleNextArrow />,
//     responsive: [
//         {
//             breakpoint: 992,
//             settings: {
//                 slidesToShow: 3,
//             },
//         },
//         {
//             breakpoint: 600,
//             settings: {
//                 slidesToShow: 2,
//             },
//         },
//         {
//             breakpoint: 480,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//             },
//         },
//     ],
// };

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    className: "center",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
        {
            breakpoint: 1092,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 414,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

export default function DraftGame({ showDrawer, setCurrentSection, bookId, pageId, userId, onGameSelect = () => { }, startGame, gameInitLoader, onEditGame = () => { }, gameEditLoader, previewGame, gameType, newMaskId }) {
    const [games, setGames] = useState([])
    const [isLoading, setLoading] = useState(true);
    const [selectedGame, setSelectedGame] = useState({})
    const [gameDeleteLoader, setGameDeleteLoader] = useState(false);
    const [getDeleteItem, setGetDeleteItem] = useState();
    const dispatch = useDispatch();
    const [deleteModal, setDeleteModal] = useState(false)
    const currentUser = useCurrentUser();
    const isAdmin = get(currentUser, "role") === "owe_admin";

    const loadData = async () => {
        setLoading(true)
        const {data} = await dispatch(handleListGame(userId, bookId, pageId, 'my_game', '1game', false, false, isAdmin));
        const filteredData = filter(data, item => item?.status === 'false');
        if (filteredData && Array.isArray(filteredData)) {
            // setGames(filteredData)
            if (gameType === 'modern') {
                const moderGame = filteredData.filter(item => item?.game_mode === 'modern');
                setGames(moderGame);
            }
            else if (gameType === 'classic') {
                const moderGame = filteredData.filter(item => item?.game_mode === 'classic');
                setGames(moderGame);
            }
            else {
                setGames(filteredData);
            }
        }
        setLoading(false);
    }
    useEffect(() => {
        loadData();
    }, [pageId, gameType])

    const onDeleteGame = async (gameData) => {
        setGameDeleteLoader(gameData?.game_id)
        await dispatch(handleGameDelete(userId, gameData?.game_id))
            .then((response) => {
                loadData()
            })
            .catch((error) => {
                // Handle any errors that occurred during the deleteGames action
                console.error('Error deleting game:', error);
            });
        setGameDeleteLoader(false)
    }

    if (isLoading) {
        return (<GameLoader />);
    }
    if (games.length == 0) {
        return (<div class="skeleton-wrapper">
            <div class="skeleton-card" style={{ textAlign: "center" }}>No games available!</div>
        </div>
        )
    }
    const handleDeleteGame = async() => {
       await onDeleteGame(getDeleteItem);
        console.log(getDeleteItem)
        setDeleteModal(false);
    }
    return (
        <>
        <Slider {...settings}>
            {games.map((item, index) => {
                const image_url = item.media_urls ? item.media_urls.image : IGameHome8
                const isGameLoading = gameInitLoader && selectedGame.game_id === item.game_id
                return (
                    <div className='myUnitsGm' key={item.id} style={{ overflow: "hidden" }}>
                        <div className='myUnitsBnr draftImage-game frameStyle'>
                            {/* <Cover src={image_url} /> */}
                            <img
                                src={image_url}
                                alt=""
                                className='imageStyle'
                            />
                            {item?.status === 'false' && (
                                <div className='draftText-game'>Draft</div>
                            )}
                            {item?.modern_type === "magic_goal" && (
                                <div className='draftText SoccerTag'>Goal</div>
                            )}
                            {item?.modern_type === "run" && (
                                <div className='draftText SoccerTag'>Run</div>
                            )}
                            {item?.modern_type === "king_jump" && (
                                <div className='draftText SoccerTag'>Jump</div>
                            )}
                            {item?.modern_type === "park" && (
                                <div className='draftText SoccerTag'>Park</div>
                            )}
                            {item?.game_mode === "classic" && (
                                <div className='draftText classiscTag'>Classic</div>
                            )}
                            {item?.modern_type === null && item?.game_mode === "modern" && (
                                <div className='draftText SoccerTag'>Modern</div>
                            )}
                        </div>
                        <div className='myUnitsTxt'>
                            <div className='myUnitsInfo'>
                                {/* <label>{item.display_name || 'Untitled'}</label> */}
                                {item?.display_name && item.display_name.length > 20 ? (
                                    <Tooltip title={item.display_name}>
                                        <label className='text-dark'>{item?.display_name.slice(0, 20) + '...'}</label>
                                    </Tooltip>
                                ) : (
                                    <label className='text-dark'>{item?.display_name || 'Untitled'}</label>
                                )}
                                <p>{item?.category?.category_name || "--"}</p>
                                {newMaskId ? (
                                    <span>Pg. {newMaskId || '--'}</span>
                                ) : (
                                    <span>Pg. {item?.sub_category?.category_name || item?.sub_category?.reference_id || '--'}</span>
                                )}
                                <span>{`No. of Questions: ${item?.question_length??0}`}</span>
                            </div>
                            <div className='myUnitsBtns'>
                                <a onClick={() => {
                                    if (item?.status === 'true' && item?.question_length > 0) {
                                        previewGame(item)
                                    }
                                }
                                } className={`BtnsPrev ${item?.status !== 'true' || item?.question_length == 0 ? "btn-disabled-game" : ''}`
                                }>Preview</a>
                                {!isAdmin && (
                                <a onClick={() => {
                                    if (isGameLoading || gameInitLoader) {
                                        return false;
                                    }
                                    if (item?.status === 'true' && item?.question_length > 0) {
                                        setSelectedGame(item);
                                        startGame(item);
                                    }
                                }}
                                    className={`BtnsStart ${item?.status !== 'true' || item?.question_length == 0 ? "btn-disabled-game" : ''}`}>
                                    <ArrowRightRounded />{gameInitLoader && selectedGame.game_id === item.game_id ? <Loading size={12} white /> : null} start
                                </a>
                                )}
                            </div>
                            <div className='myUnitsBtm'><p><CheckCircleRounded /> My Creation</p></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="px-4">
                                <div onClick={() => {
                                    onEditGame(item)
                                }}>
                                    <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>Edit{gameEditLoader === item.game_id ? <Loading size={15} /> : null}</p>
                                </div>
                                <div onClick={() => {
                                    setGetDeleteItem(item)
                                    // onDeleteGame(item)
                                    setDeleteModal(true);
                                }}>
                                    {/* <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>{gameDeleteLoader === item.game_id ? <Loading size={12} /> : null} Delete </p> */}
                                    <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>Delete </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </Slider>
            <DeleteModal
                message={`Do you really want to delete this game, "${getDeleteItem?.display_name ?? 'Untitled'}"`}
                deleteToggle={deleteModal}
                setDeleteToggle={setDeleteModal}
                loading={gameDeleteLoader}
                onDelete={handleDeleteGame}

            />
        </>
    )
}